export const LanguageEnum = {
    FR: "fr",
    EN: "en",
};